const classNames = {
    active: "active",
};

export default class Overlay {
    private container: HTMLElement;
    private overlayContent: HTMLElement;
    private overlayOpenButton: HTMLElement;
    private overlayCloseButton: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;

        this.overlayContent = this.container.querySelector(".overlay");
        this.overlayOpenButton = this.container.querySelector("a");
        this.overlayCloseButton = this.container.querySelector(".close-button");

        this.overlayOpenButton.addEventListener("click", () => {
            this.toggleAsideNavContentVisibility();
            this.focusElementWithTimeout(this.overlayCloseButton);
        });

        this.overlayCloseButton.addEventListener("click", () => {
            this.toggleAsideNavContentVisibility();
        });
    }

    /* set focus to element with timeout (so it is already visible, otherwise the focus is not set) */
    private focusElementWithTimeout(element: HTMLElement) {
        setTimeout(() => {
            element.focus();
        }, 100);
    }

    private toggleAsideNavContentVisibility() {
        this.overlayContent.classList.toggle(classNames.active);
    }
}
